import React, { FC, useEffect } from 'react';
import { RawMoney } from '@edreamsodigeo/prisma-design-system';
import {
  createFeature,
  Trans,
  useTranslation,
} from '@edreamsodigeo/frontend-core';
import { usePFTracking } from 'clientState/hooks/usePFTracking';
import { withUserLoggedCheck } from 'clientState/hooks/priceFreezeHooks';
import { Money } from 'generated/graphql';
import { PRICE_FREEZE_PRIME_FIRST_PHASE_2_MOBILE } from 'clientState/ab/aliases';

const PAGE = 'flights_results' as const;

export type PriceFreezePromotionalTextProps = {
  deposit: Money | null;
  isPrimeUser: boolean;
  shortMessage: boolean;
};

export const PriceFreezePromotionalText: FC<PriceFreezePromotionalTextProps> =
  createFeature({
    name: PRICE_FREEZE_PRIME_FIRST_PHASE_2_MOBILE,
    variations: [
      withUserLoggedCheck(PriceFreezePromotionalTextComponent),
      PriceFreezePromotionalTextComponent,
    ],
    version: 1,
  });

export function PriceFreezePromotionalTextComponent({
  deposit,
  isPrimeUser = false,
  shortMessage = false,
}: PriceFreezePromotionalTextProps) {
  const { t } = useTranslation();
  const { trackLoadOnce } = usePFTracking('price-freeze-tag');
  const textKey = shortMessage
    ? 'low.deposit.initiative.txt.freezeprice'
    : 'pricefreeze.promotional.results.text';

  useEffect(() => {
    const isPrime = isPrimeUser ? 'yes' : 'no';
    trackLoadOnce(
      `price-freeze-tag_onload:results-card_prime:${isPrime}_pag:${PAGE}`
    );
  }, [trackLoadOnce, deposit, isPrimeUser]);

  return (
    <>
      {isPrimeUser ? (
        <Trans
          i18nKey={textKey}
          components={{
            deposit: <DepositStyled money={deposit} />,
            price: <DepositStyled money={deposit} />,
          }}
        />
      ) : (
        t('pricefreeze.card.cta')
      )}
    </>
  );
}

function DepositStyled({
  money,
}: {
  money: Money | null;
}): React.ReactElement | null {
  if (!money || money.amount == null) {
    return null;
  }

  return (
    <RawMoney currency={money?.currency || ''} rounded={true}>
      {Math.floor(money.amount)}
    </RawMoney>
  );
}
